module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.1878/img/provider-ctas-blob-2x.png"